import React from "react";
import { useState, useEffect } from "react";
import instance from "../../services/ApiServices";
import { motion } from "motion/react";

// import Navigation from "../ApiServices/NAvigationServices";

function Aboutus() {
  const endpoint = "location";

  const [Location, setLocation] = useState([]);

  useEffect(() => {
    instance.get(endpoint).then((res) => {
      const datarcd = res.data[0];
      // console.log("My Image:"+JSON.stringify(datarcd));
      setLocation(datarcd);
      // console.log("Gallery Items :"+JSON.stringify(galleryitems));
    });
  }, []);
  return (
    <div
      id="aboutus"
      className="wrapper bg-primary mt-24 py-0"
    >
      {Location && (
        <div className="container grid grid-cols-1 md:grid-cols-2 min-h-[600px] bg-white p-0">
          <div
            className="flex flex-row text-black items-center p-10 lg:p-14
       "
          >
            <div>
              <motion.h1
                initial={{ x: 100, opacity: 0 }}
                whileInView={{
                  x: 0,
                  opacity: 1,
                  transition: {
                    delay: 0.5,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 0.6 },
                    ease: "easeIn",
                  },
                }}
                className="text-4xl lg:text-6xl font-semibold mb-10 pt-10"
              >
                About Us
              </motion.h1>
              <motion.p
                className="line-height-10 text-lg lg:text-xl"
                initial={{ x: 200, opacity: 0 }}
                whileInView={{
                  x: 0,
                  opacity: 1,
                  transition: {
                    delay: 0.5,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 0.6 },
                    ease: "easeIn",
                  },
                }}
                dangerouslySetInnerHTML={{ __html: Location.description }}
              />
            </div>
          </div>
          <motion.div
            initial={{ x: -150, opacity: 0 }}
            whileInView={{
              x: 0,
              opacity: 1,
              transition: {
                delay: 0.5,
                x: { type: "spring", stiffness: 60 },
                opacity: { duration: 0.6 },
                ease: "easeIn",
              },
            }}
            className="flex justify-center overflow-hidden "
          >
            <img
              className="object-cover w-full "
              src={Location.image}
              alt=""
            />
          </motion.div>
        </div>
      )}
    </div>
  );
}

export default Aboutus;
